import React from "react";
import styled from "styled-components";
import { FiAlertCircle } from "react-icons/fi";
import { Card } from "../Card";

const EmptyStateWrapper = styled(Card)`
  padding: 48px 24px;
  text-align: center;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  svg {
    font-size: 48px;
    color: ${({ theme }) => theme.colors.verae[300]};
    margin-bottom: 16px;
  }

  h3 {
    margin: 0 0 8px 0;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 600;
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 14px;
  }
`;

interface EmptyStateProps {
  title?: string;
  message?: string;
  error?: Error | null;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
  title = "No Records Found", 
  message = "There are no device records available.", 
  error = null 
}) => {
  return (
    <EmptyStateWrapper>
      <FiAlertCircle />
      <h3>{title}</h3>
      <p>{message}</p>
      {error && (
        <p style={{ color: "#e53935", marginTop: "10px", fontWeight: 500 }}>
          {error.message}
        </p>
      )}
    </EmptyStateWrapper>
  );
};
